import { CanMarshal } from "./canMarshal.model";

export class AppBaseNotification extends CanMarshal<AppBaseNotification> {
	uuid: string
	type: string
	createdAt: string
	completedAt: string
	viewedAt: string
	content: any
}